import {store} from "../store";
import appConfig from "../appconfig";
import UserNotificationsProvider from "../providers/UserNotificationsProvider";

export default {
	createUserNotification: async function(notification) {
		const {notificationsEnabled} = store.getters.featureToggles;
		const {applicationUserIdpToken, applicationUserLoggedIn} = store.getters;
		const {tenantId} = appConfig;
		if (notificationsEnabled && applicationUserLoggedIn && tenantId === 100) {
			const {id, title, body} = notification;
			if (title && body) {
				const data = {id, message: body, title, isRead: false};
				UserNotificationsProvider.create(tenantId, applicationUserIdpToken, data);
			}
		}
	},
	createUserNotificationOnPushNotificationTap: async function(router, obj) {
		const {notificationsEnabled} = store.getters.featureToggles;
		const {applicationUserIdpToken, applicationUserLoggedIn} = store.getters;
		const {tenantId} = appConfig;
		if (notificationsEnabled && applicationUserLoggedIn && tenantId === 100) {
			const {_body, _title} = obj.notification.data;
			if (_body && _title) {
				UserNotificationsProvider.create(tenantId, applicationUserIdpToken, {id: obj.notification.id, message: _body, title: _title, isRead: true}).then(() => {
					router.push(`/notifications?id=${encodeURIComponent(obj.notification.id)}`);
				});
			}
		}
	},
	showNotifications() {
		const {applicationUserLoggedIn} = this.$store.getters;
		const {notificationsEnabled} = this.featureToggles;
		return applicationUserLoggedIn && notificationsEnabled && appConfig.mobile.isMobileApp();
	}
};